/**
 * code: 1 ユーザーが位置情報を許可していない場合
 * code: 2 HTTP通信で位置情報を取得しようとした場合など
 * code: 3 位置情報が制限時間内に取得できない場合
 *
 * https://developer.mozilla.org/ja/docs/Web/API/GeolocationPositionError/code
 */
export const geolocationPositionErrorList = {
  1: {
    code: 1,
    message: "位置情報を許可してください。",
  },
  2: {
    code: 2,
    message: "位置情報の取得に失敗しました。再操作をお願いします。",
  },
  3: {
    code: 3,
    message:
      "通信環境が良い場所で、再操作をお願いします。\nAndroidの場合は位置情報設定を高精度に変更する事で改善される場合があります。",
  },
};

export const getLocationWithPromise = ({
  timeout = 5000,
  options = { maximumAge: 0, timeout: 5000, enableHighAccuracy: false },
} = {}) => {
  return new Promise((resolve, reject) => {
    /**
     * iOS 16.4でのLIFFブラウザおよびLINE内ブラウザの障害
     * navigator.geolocation.getCurrentPosition(onSuccess, onError, {timeout: 1000})というコードの
     * onSuccessとonErrorというコールバックがいずれも呼ばれずに、常に待機状態のままとなってしまう。
     * 上記の障害がある為、独自のタイムアウトの処理を追加している。
     */
    const timeoutId = setTimeout(() => {
      console.error("タイムアウトエラー");
      reject(geolocationPositionErrorList[3]);
    }, timeout);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        clearTimeout(timeoutId);
        resolve(position);
      },
      (error) => {
        console.error(error);
        clearTimeout(timeoutId);
        reject(geolocationPositionErrorList[error.code]);
      },
      options
    );
  });
};
